import { render, staticRenderFns } from "./mediateSupplement.vue?vue&type=template&id=6dc074c4&scoped=true&"
import script from "./mediateSupplement.vue?vue&type=script&lang=js&"
export * from "./mediateSupplement.vue?vue&type=script&lang=js&"
import style0 from "./mediateSupplement.vue?vue&type=style&index=0&id=6dc074c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc074c4",
  null
  
)

export default component.exports